import { createSlice } from "@reduxjs/toolkit";
import { normalizeRoleCode } from "../../utils/credentialPermissions";

const initialState = {
  user: null,
  roleNames: [],
  roleCodes: [],
  isAuthenticated: false,
  isLoggedOut: false,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      if (action.payload?.accessToken) {
        state.user = action.payload;
        state.isAuthenticated = true;
        state.roleNames = action.payload?.roles?.map((role) => role.name) ?? [];
        state.roleCodes =
          action.payload?.roles?.map((role) => normalizeRoleCode(role.code ?? role.name)) ?? [];
      }
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      state.isLoggedOut = true;
      state.roleNames = [];
      state.roleCodes = [];
    },
  },
});

export const { setCredentials, logout } = authSlice.actions;
